import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import api from "../lib/api";
import SEO from "../lib/SEO";
import SmartImage from "../components/SmartImage";
import { useSettings } from "../lib/SettingsContext";

export default function Blog() {
    const { settings } = useSettings();
    const [posts, setPosts] = useState([]);
    useEffect(() => {
        api.get("/blogs").then((r) => setPosts(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    }, []);

    return (
        <main data-testid="blog-page">
            <SEO title="Blog — Cake Central" description="Cake design tips, flavour pairings, and Sydney cake trends." path="/blog" />
            <PageBanner
                eyebrow="Stories from the studio"
                title="Cake Central Blog"
                image={settings?.banner_blog || "https://images.unsplash.com/photo-1700448293876-07dca826c161?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"}
            />

            <section className="bg-[#FFF7FB] py-14 md:py-20">
                <div className="px-4 sm:px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 max-w-screen-2xl mx-auto">
                    {posts.map((p, i) => (
                        <Link
                            key={p.id}
                            to={`/blog/${p.slug}`}
                            className="group block bg-white border border-[#EAE3DE] card-lift overflow-hidden"
                            data-testid={`blog-card-${i}`}
                        >
                            <div className="aspect-[16/10] overflow-hidden">
                                <SmartImage src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                            </div>
                            <div className="p-5">
                                <p className="text-[10px] tracking-[0.3em] uppercase text-ink-soft mb-2">
                                    {new Date(p.created_at).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}
                                </p>
                                <h3 className="font-display text-xl text-ink mb-2 leading-tight">{p.title}</h3>
                                <p className="text-sm text-ink-soft line-clamp-3">{p.excerpt}</p>
                                <p className="mt-4 text-[10px] tracking-[0.25em] uppercase text-blush">Read article →</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </main>
    );
}
